import { adminList, adminDashboard } from "constants/admin";

const initialState = {
  adminList: {},
  adminDashboard: {},
};

const admin = (state = initialState, action) => {
  switch (action.type) {
    case adminList:
      return { ...state, adminList: action.payload };

    case adminDashboard:
      return { ...state, adminDashboard: action.payload };

    default:
      return state;
  }
};

export default admin;